import {downloadRrcEp10WasteManifest} from "@ots-frontend/ots-data";
import {useCallback, useEffect} from "react";
import {notifications} from "@mantine/notifications";
import {useTranslation} from "react-i18next";
import {useApp} from "../providers/RegionProvider/RegionProvider"
import {useDebouncedState} from "@mantine/hooks";
import {BaseQueryApi} from "@reduxjs/toolkit/query";

export type UseDownloadRrcEp10WasteManifestProps = {
  baseQueryApi: BaseQueryApi
}

export type UseDownloadRrcEp10WasteManifestResult = {
  downloadRrcEp10WasteManifest: (id: string, tenantCode: string | undefined) => void
}

export const useDownloadRrcEp10WasteManifest = (props: UseDownloadRrcEp10WasteManifestProps): UseDownloadRrcEp10WasteManifestResult => {
  const {baseQueryApi} = props

  const {t} = useTranslation(["common"])

  // state
  const [_downloading, _setDownloading] = useDebouncedState(false, 500)

  useEffect(() => {
    _setDownloading(_downloading)
  }, [_downloading, _setDownloading])


  useEffect(() => {
    if (_downloading) {
      notifications.show({
        id: "useDownloadRrcEp10WasteManifest_downloading",
        title: t("common.status.downloading", "Downloading") + " " + t("common.entity.rrcep10wastemanifest", "RRC EP10 Waste Manifest"),
        message: "",
        loading: true,
        autoClose: false,
      });
    } else {
      notifications.hide("useDownloadRrcEp10WasteManifest_downloading")
    }
  }, [_downloading, t]);

  const _handleError = useCallback((rejected: any) => {
    notifications.show({
      color: "red",
      title: t("common.error", "Error"),
      message: rejected?.data?.detail ?? t("common.error", "Error", {ns: "common"}),
    })
  }, [t])

  const _downloadRrcEp10WasteManifest = useCallback((id: string, tenantCode: string | undefined) => {
    _setDownloading(true)

    downloadRrcEp10WasteManifest(id, tenantCode, baseQueryApi)
      .then((response) => {
        response.text()
          .then((url) => {
            _setDownloading(false)

            const a = document.createElement('a');
            a.href = url;
            a.target = "_blank"
            a.click();

            notifications.show({
              color: "green",
              title: t("common.entity.rrcep10wastemanifest", "RRC EP10 Waste Manifest") + " " + t("common.status.downloaded", "Downloaded"),
              message: ""
            });
          })
          .catch((rejected) => {
            _handleError(rejected)
          })
          .finally(() => {
            _setDownloading(false)
          })
      })
      .catch((rejected) =>
        _handleError(rejected)
      )
      .finally(() => {
        _setDownloading(false)
      })
  }, [_setDownloading, baseQueryApi, t, _handleError])

  return {
    downloadRrcEp10WasteManifest: _downloadRrcEp10WasteManifest,
  }
}
